import React from "react";
import { IntlProvider } from "react-intl";

import LoaderSpinner from "../helpers/LoaderSpinner";
import CustomIntlProviderBase from "./CustomIntlProvider";
import { withStyles } from "@material-ui/core";
import Error from "../helpers/Error";

const styles = (theme) => ({
  centerContainer: {
    width: "100%",
    height: "550px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
});

//TODO: Translations are not yet loaded, so the message is fixed in pt-BR
const errors = {
  title: "Não conseguimos carregar este conteúdo",
  subtitle:
    "Encontramos uma instabilidade interna. Tente novamente em instantes.",
  action: "Tentar novamente",
};

class CustomIntlEmbeddedProvider extends CustomIntlProviderBase {
  render() {
    const { translations, loaded, error } = this.state;
    const { children, locale, classes } = this.props;
    let language = !!translations[locale] ? locale : locale.substr(0, 2);

    if (!loaded) {
      return (
        <div className={classes.centerContainer}>
          <LoaderSpinner />
        </div>
      );
    }

    if (loaded && error) {
      return (
        <div className={classes.centerContainer}>
          <Error
            title={errors.title}
            subtitle={errors.subtitle}
            actionLabel={errors.action}
            action={() => this.checkTranslations()}
          />
        </div>
      );
    }

    return (
      <IntlProvider locale={locale} messages={translations[language]}>
        {children}
      </IntlProvider>
    );
  }
}

export default withStyles(styles)(CustomIntlEmbeddedProvider);
